import { defineStore } from 'pinia'

import type { DisciplineStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineStore = defineStore('discipline', {
  state: (): DisciplineStore => ({
    discipline: null,
    details: null,
    customerGo: false,
    customerPremium: false,
    customerGoId: null,
    contextLoading: false,
  }),
  actions,
  getters,
})